import { getHostValue, getLayout, NATIVE } from 'owa-config';

export const ecsWebClient =
    getLayout() === 'Phone' ? 'OWAMini' : getHostValue() === NATIVE ? 'Win32Monarch' : 'OWADesktop';
